// 轻量活跃度采集（前端）
// - 发送到 /api/activity/collect
// - 失败静默，不影响用户体验

export async function trackEvent(payload) {
  try {
    const body = JSON.stringify(payload || {});
    // 优先用 fetch keepalive（页面卸载也尽量送达）
    await fetch('/api/activity/collect', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body,
      keepalive: true,
      credentials: 'include'
    });
  } catch (_) {
    // ignore
  }
}

export function trackPageView({ path, title, referrer } = {}) {
  return trackEvent({
    event_type: 'page_view',
    path: path || window.location.pathname + window.location.search + window.location.hash,
    title: title || document.title || '',
    referrer: referrer || document.referrer || ''
  });
}

export function trackHeartbeat({ path, durationSeconds = 30 } = {}) {
  return trackEvent({
    event_type: 'heartbeat',
    path: path || window.location.pathname + window.location.search + window.location.hash,
    duration_seconds: Math.max(0, Math.min(3600, parseInt(durationSeconds, 10) || 0))
  });
}

